module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Meet"
  }, [_c('div', {
    staticClass: "Meet-container"
  }, [_c('div', {
    staticClass: "Meet-header"
  }, [_c('p', {
    staticClass: "Meet-title t-headingMd"
  }, [_vm._v("Meet " + _vm._s(this.animal.name) + "!")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "Meet-map"
  }, [_c('img', {
    staticClass: "Meet-mapImage",
    attrs: {
      "src": _vm.image
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "Meet-subtitle"
  }, [_vm._v("\n        A PetSpace representatitve is available to help you connect."), _c('br'), _vm._v(" Just follow the path below to our PetConnect center.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6b9337"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Meet.vue
// module id = 425
// module chunks = 1